import { z } from "zod";
// The places of the request form (CHT-1983): `GET /customer/catalog/places`. One entry for each city that has at least one PUBLISHED
// catalog item with a locality and a time zone, so the form can offer every city the catalog really holds. The answer is a closed list of
// keys. It has no item, no count, no price, no draft and no staff field. `timeZone` is the IANA zone of the items of that city; it is what a
// request sends as its clock.
/** The most cities of one answer. The catalog has far fewer; a longer list is a defect of the server, not a page to continue. */
export const CUSTOMER_CATALOG_PLACES_MAX = 200;
export const customerCatalogPlaceSchema = z.strictObject({
    locality: z.string().min(1).max(100),
    countryCode: z.string().regex(/^[A-Z]{2}$/u),
    timeZone: z.string().min(1).max(64),
});
export const customerCatalogPlacesSchema = z.strictObject({
    places: z.array(customerCatalogPlaceSchema).max(CUSTOMER_CATALOG_PLACES_MAX),
});
